"use strict";

exports.__esModule = true;
exports.translateOptins = void 0;
var _index = require("./index");
var _WebRequestHelper = require("./WebRequestHelper");
const translateOptins = (languageCode, data) => {
  let keysArray = [];
  let keysString = '';
  return new Promise((resolve, reject) => {
    for (let i = 0; i < data.length; i++) {
      data[i].TitleTranslationId && keysArray.push(data[i].TitleTranslationId);
      data[i].TextTranslationId && keysArray.push(data[i].TextTranslationId);
      keysString = keysArray.join(',');
    }
    return (0, _WebRequestHelper.createRequest)(true).then(request => {
      let params = (0, _index.paramsToString)({
        partitionkeys: languageCode,
        sortkeys: keysString
      });
      request.method = 'get';
      request.url = `/translationentries${params}`;
      return (0, _WebRequestHelper.sendRequest)(request).then(response => {
        resolve(response);
      }).catch(err => {
        console.log(err);
        resolve();
      });
    }).catch(err => {
      console.log(err);
      resolve();
    });
  }).catch(err => console.log(err));
};
exports.translateOptins = translateOptins;